import { attributes, define } from "@type-r/models";
import { Loading } from "lqx-react";
import * as React from "react";
import { globalStore } from "api";
import { OpenItems } from "../../common/open-items";
import { PendingActionsInvoices } from "../../api";

@define 
export class UpcommingInvoicesState extends attributes({
    viaInbInvoices: [PendingActionsInvoices],
    outOfInbInvoices: [PendingActionsInvoices],
    numOfViaInb:Number,
    numOfOutInb:Number,
    isReady: Boolean
}){
    async fetch(){   
        const upcomingInvoices = await PendingActionsInvoices.fetchUpcomingInvoices();
        this.viaInbInvoices.set(upcomingInvoices.viaInbInvoices);
        this.outOfInbInvoices.set(upcomingInvoices.outOfInbInvoices);

        this.viaInbInvoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });
        
        this.outOfInbInvoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        this.numOfViaInb = this.viaInbInvoices.reduce((sum:number, curr) => sum + (curr ? curr.count : 0), 0);
        this.numOfOutInb = this.outOfInbInvoices.reduce((sum:number, curr) => sum + (curr ? curr.count : 0), 0);

        return this;
    } 

    getCount(){
        return this.numOfViaInb + this.numOfViaInb;
    }
}

export const UpcomingInvoices = ({ state }: { state: UpcommingInvoicesState }) => {

    return (
        state.isReady
            ? <>
                <OpenItems
                    title={`Open items - SOA sent via InBlock (${state.numOfViaInb})`}
                    invoices={state.viaInbInvoices}
                    linkUrl='/invoices/statement'
                    bucket='due2weeks'
                    hasPromiseToPayOverdue={false}
                    hasSoaSentDate={true}/>
                
                <OpenItems
                    title={`Open items - SOA sent outside InBlock (${state.numOfOutInb})`}
                    invoices={state.outOfInbInvoices}
                    linkUrl='/invoices/statement'
                    bucket='due2weeks'
                    hasPromiseToPayOverdue={false}/>
            </>
            : <Loading />
    );
}